import { createContext } from 'react';

export interface IDropdownMenuContext {
  (handler: () => void): void;
}

const DropdownMenuContext = createContext<IDropdownMenuContext>(() => null);

export default DropdownMenuContext;
